<template>
    <div class="data-container">
        <el-tabs class="elTabs" v-model="tab_active" @tab-change="tabChange">
            <el-tab-pane label="温采设备监测" name="1"></el-tab-pane>
            <el-tab-pane label="管道传感器监测" name="2"></el-tab-pane>
            <el-tab-pane label="智能控制阀监测" name="3"></el-tab-pane>
        </el-tabs>
        <div class="tool-box">
            <el-button type="primary" :icon="Refresh" @click="resetQueryForm">刷新</el-button>
            <el-button
                :icon="Upload"
                :disabled="!table_data.length"
                @click="exportData"
                v-permission="['factory:monitors:batch-export']"
            >
                最新数据导出
            </el-button>
        </div>
        <el-form :inline="true" label-width="60">
            <el-form-item label="IMEI">
                <div class="imei-box">
                    <el-input v-model="search_data.imei" placeholder="请输入IMEI" clearable style="width: 260px" />
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" :icon="Search" @click="handleSearch">搜索</el-button>
                <el-button :icon="Refresh" @click="resetQueryForm">重置</el-button>
            </el-form-item>
        </el-form>
        <el-table v-if="tab_active === '1'" :data="table_data" border v-loading="tableLoading">
            <el-table-column label="采集时间" prop="data_ts" min-width="150" fixed="left"></el-table-column>
            <el-table-column label="上传时间" prop="ts" min-width="150"></el-table-column>
            <el-table-column label="室温（℃）" prop="roottemp" min-width="110">
                <template #header>
                    <p>室温</p>
                    <p>(℃)</p>
                </template>
                <template #default="{ row }">{{ row.roottemp }}</template>
            </el-table-column>
            <el-table-column label="湿度（%）" prop="humidity" min-width="110">
                <template #header>
                    <p>湿度</p>
                    <p>%</p>
                </template>
                <template #default="{ row }">
                    <template v-if="row?.humidity <= 100">{{ row.humidity }}%</template>
                    <template v-else>--</template>
                </template>
            </el-table-column>
            <el-table-column label="信号强度" prop="csq">
                <template #default="{ row }">
                    <div class="signal-box">
                        <span class="num">{{ row.csq }}</span>
                        <div class="signal">
                            <span
                                v-for="num of 5"
                                class="bar"
                                :key="num"
                                :class="['bar' + num, num <= Math.floor(row.csq / 6) ? 'active' : '']"
                            ></span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="电池" width="80px" prop="bat">
                <template #header>
                    <p>电池</p>
                    <p>(%)</p>
                </template>
                <template #default="{ row }">
                    <span v-if="row.bat <= 100">{{ row.bat }}</span>
                    <span v-else></span>
                </template>
            </el-table-column>
            <el-table-column label="告警标记" prop="flags" min-width="150">
                <template #default="{ row }">
                    <span v-show="(row.flags & (1 << 7)) !== 0">掉电故障</span>
                    <span v-show="(row.flags & (1 << 7)) !== 0 && (row.flags & (1 << 6)) !== 0">，</span>
                    <span v-show="(row.flags & (1 << 6)) !== 0">移位故障</span>
                </template>
            </el-table-column>
        </el-table>
        <el-table v-else-if="tab_active === '2'" :data="table_data" border v-loading="tableLoading">
            <el-table-column label="采集时间" prop="data_ts" min-width="150" fixed="left"></el-table-column>
            <el-table-column label="上传时间" prop="ts" min-width="150"></el-table-column>
            <el-table-column label="入水温度（℃）" prop="roottemp" min-width="110">
                <template #header>
                    <p>入水温度</p>
                    <p>(℃)</p>
                </template>
                <template #default="{ row }">{{ row.roottemp }}</template>
            </el-table-column>
            <el-table-column label="出水温度（%）" prop="humidity" min-width="110">
                <template #header>
                    <p>出水温度</p>
                    <p>%</p>
                </template>
                <template #default="{ row }">
                    <template v-if="row?.humidity <= 100">{{ row.humidity }}%</template>
                    <template v-else>--</template>
                </template>
            </el-table-column>
            <el-table-column label="信号强度" prop="csq">
                <template #default="{ row }">
                    <div style="display: flex">
                        <span>{{ row.csq }}</span>
                        &nbsp;
                        <div class="csq">
                            <span
                                v-for="num of 5"
                                class="bar"
                                :key="num"
                                :class="['bar' + num, num <= Math.floor(row.csq / 6) ? 'active' : '']"
                            ></span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="电池" width="80px" prop="bat">
                <template #header>
                    <p>电池</p>
                    <p>(%)</p>
                </template>
                <template #default="{ row }">
                    <span v-if="row.bat <= 100">{{ row.bat }}</span>
                    <span v-else></span>
                </template>
            </el-table-column>
            <el-table-column label="告警标记" prop="flags" min-width="150">
                <template #default="{ row }">
                    <span v-show="(row.flags & (1 << 7)) !== 0">掉电故障</span>
                    <span v-show="(row.flags & (1 << 7)) !== 0 && (row.flags & (1 << 6)) !== 0">，</span>
                    <span v-show="(row.flags & (1 << 6)) !== 0">移位故障</span>
                </template>
            </el-table-column>
        </el-table>
        <el-table v-else-if="tab_active === '3'" :data="table_data" border v-loading="tableLoading">
            <el-table-column label="采集时间" prop="data_ts" min-width="150" fixed="left"></el-table-column>
            <el-table-column label="上传时间" prop="ts" min-width="150"></el-table-column>
            <el-table-column label="阀门状态" width="100px" prop="opening">
                <template #default="{ row }">
                    <el-tag v-if="row.opening > 0" type="success">开</el-tag>
                    <el-tag v-else type="danger">关</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="阀门开度" width="100px" prop="opening">
                <template #default="{ row }">{{ row.opening ?? '--' }}%</template>
            </el-table-column>
            <el-table-column width="100px" prop="intemp">
                <template #header>
                    <p>进水温度</p>
                    <p>(℃)</p>
                </template>
                <template #default="{ row }">{{ row.intemp <= 100 && row.intemp >= -100 ? row.intemp : '--' }}</template>
            </el-table-column>
            <el-table-column width="100px" prop="outtemp">
                <template #header>
                    <p>出水温度</p>
                    <p>(℃)</p>
                </template>
                <template #default="{ row }">{{ row.outtemp <= 100 && row.outtemp >= -100 ? row.outtemp : '--' }}</template>
            </el-table-column>
            <el-table-column label="信号强度" prop="csq">
                <template #default="{ row }">
                    <div class="signal-box">
                        <span class="num">{{ row.csq }}</span>
                        <div class="signal">
                            <span
                                v-for="num of 5"
                                class="bar"
                                :key="num"
                                :class="['bar' + num, num <= Math.floor(row.csq / 6) ? 'active' : '']"
                            ></span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <!--            <el-table-column label="周期" width="110px" prop="upperi">
                <template #header>
                    <p>周期</p>
                    <p>(分钟)</p>
                </template>
                <template #default="{ row }">{{ row.upperi }}</template>
            </el-table-column>-->
            <el-table-column label="电量" width="80px" prop="bat">
                <template #header>
                    <p>电量</p>
                    <p>(%)</p>
                </template>
                <template #default="{ row }">
                    <span v-if="row.bat <= 100">{{ row.bat }}</span>
                    <span v-else></span>
                </template>
            </el-table-column>
            <el-table-column label="电压（V）" width="100px" prop="voltage">
                <template #default="{ row }">
                    <span v-if="row.voltage && row.voltage <= 100">
                        {{ (Math.round(row.voltage * 10) / 10).toFixed(1) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="累计流量（m³/h）" width="100px" prop="accflow">
                <template #default="{ row }">
                    <span v-if="row.flow && row.flow <= 100">
                        {{ (Math.round(row.flow * 10) / 10).toFixed(1) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="瞬时流量（m³/h）" width="100px" prop="instflow">
                <template #default="{ row }">
                    <span v-if="row.flow_instant && row.flow_instant <= 100">
                        {{ (Math.round(row.flow_instant * 10) / 10).toFixed(1) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="累计热量（kwh）" width="100px" prop="accheat">
                <template #default="{ row }">
                    <span v-if="row.heat && row.heat <= 100">
                        {{ (Math.round(row.heat * 10) / 10).toFixed(1) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="累计冷量（kwh）" width="100px" prop="acccool">
                <template #default="{ row }">
                    <span v-if="row.cold && row.cold <= 100">
                        {{ (Math.round(row.cold * 10) / 10).toFixed(1) }}
                    </span>
                </template>
            </el-table-column>
            <el-table-column label="告警标记" width="160px">
                <template #default="{ row }">
                    <el-tag type="danger" v-if="(row.flags & (1 << 0)) !== 0">市电掉电报警</el-tag>
                    <el-tag type="danger" v-if="(row.flags & (1 << 1)) !== 0">电池低电压报警</el-tag>
                    <el-tag type="danger" v-if="(row.flags & (1 << 2)) !== 0">防拆报警</el-tag>
                    <el-tag type="danger" v-if="(row.flags & (1 << 3)) !== 0">阀门堵转</el-tag>
                    <el-tag type="danger" v-if="(row.flags & (1 << 4)) !== 0">温度传感器故障</el-tag>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            v-if="total > 0"
            class="pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination_data.page"
            :page-size="pagination_data.page_size"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        />
    </div>
</template>

<script setup>
import { onMounted, reactive, ref } from 'vue'
import { Refresh, Search, Upload } from '@element-plus/icons'
import { getEquipModelTree } from '@/api/equipment.js'
import { getOptionTree } from '@/api/room.js'
import { ElLoading, ElMessage, ElMessageBox } from 'element-plus'
// import { getDevicesRecord } from '@/api/heating/monitoring.js'
import Exceljs from 'exceljs'
import FileSaver from 'file-saver'
import { getFactoryDeviceList } from '@/api/factory.js'
import { getDeviceRecord } from '@/api/heating/monitoring.js'

// 标签页
const tab_active = ref('1')
function tabChange(tab) {
    tab_active.value = tab
    search_data.value = {
        imei: ''
    }
    table_data.value = []
}

// 型号列表
const model_list = ref({})
async function getModelList() {
    await getEquipModelTree().then((data) => {
        const list = {}
        data.forEach((device_type) => {
            device_type?.children &&
                device_type.children.forEach((device_model) => {
                    list[device_model.id] = {
                        type: device_type.name,
                        model: device_model.name
                    }
                })
        })
        model_list.value = list
    })
}

// 安装位置
const room_list = ref({})
async function getRoomTree() {
    await getOptionTree().then((data) => {
        const room_locations = {}

        function getRoom(list, location) {
            list.forEach((item) => {
                if (item.children) {
                    getRoom(item.children, location + '/' + item.name)
                } else {
                    room_locations[item.id] = location.slice(1) + '/' + item.name
                }
            })
        }

        getRoom(data[0]?.children ?? [], '')
        room_list.value = room_locations
    })
}

// 搜索IMEI
const search_data = ref({
    imei: ''
})

// 搜索回到第一页
const handleSearch = () => {
    pagination_data.page = 1
    getTableData()
}

// 重置
const resetQueryForm = () => {
    search_data.value = {
        imei: ''
    }
    pagination_data.page = 1
    table_data.value = []
}

// 格式化对象
const getNowDate = () => {
    const date = new Date()
    const sign2 = ':'
    const year = date.getFullYear() // 年
    let month = date.getMonth() + 1 // 月
    let day = date.getDate() // 日
    let hour = date.getHours() // 时
    let minutes = date.getMinutes() // 分
    let seconds = date.getSeconds() // 秒
    if (month >= 1 && month <= 9) {
        month = '0' + month
    }
    if (day >= 0 && day <= 9) {
        day = '0' + day
    }
    if (hour >= 0 && hour <= 9) {
        hour = '0' + hour
    }
    if (minutes >= 0 && minutes <= 9) {
        minutes = '0' + minutes
    }
    if (seconds >= 0 && seconds <= 9) {
        seconds = '0' + seconds
    }
    return year + '-' + month + '-' + day + ' ' + hour + sign2 + minutes + sign2 + seconds
}

// 刷新时间
const dateTime = ref('')
function refreshTime() {
    dateTime.value = getNowDate()
}

// 分页相关
const pagination_data = reactive({
    page: 1,
    page_size: 20
})
const total = ref(0)
const handleSizeChange = (currentSize) => {
    pagination_data.page_size = currentSize
    pagination_data.page = 1
    getTableData()
}
const handleCurrentChange = (currentPage) => {
    pagination_data.page = currentPage
    getTableData()
}
const table_data = ref([])
const tableLoading = ref(false)
async function getTableData() {
    tableLoading.value = true
    const params = pagination_data
    params.imei = search_data.value.imei
    params.type = Number(tab_active.value)
    const result = await getFactoryDeviceList(params)
    table_data.value = result.lists
    total.value = result.total
    refreshTime()
    tableLoading.value = false
}

// 表格多选
const selected_list = ref([])
function handleSelectionChange(list) {
    selected_list.value = list.map((item) => {
        return item.id
    })
}

// 最新数据导出
function exportData() {
    ElMessageBox.confirm('是否确认导出设备数据', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(async () => {
        const loading = ElLoading.service({
            lock: true,
            text: '正在导出...',
            spinner: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
        let list = []
        const params = {
            page_size: total.value
        }
        params.imei = search_data.value.imei
        params.type = Number(tab_active.value)
        await getFactoryDeviceList(params).then((data) => {
            list = data.lists
        })
        if (list.length <= 0) {
            loading.close()
            return ElMessage.error('没有数据可导出')
        }
        // 创建excel并写入数据
        let workbook = null
        workbook = new Exceljs.Workbook()
        workbook.created = new Date()
        workbook.modified = new Date()
        workbook.lastPrinted = new Date()
        const worksheet = workbook.addWorksheet('订单', {
            properties: {
                defaultRowHeight: 22
            },
            pageSetup: {
                horizontalCentered: true
            }
        })
        if (Number(tab_active.value) === 1) {
            worksheet.columns = [
                {
                    header: 'IMEI',
                    key: 'IMEI',
                    width: 20
                },
                {
                    header: 'ICCID',
                    key: 'iccid',
                    width: 22
                },
                {
                    header: '上传时间',
                    key: 'ts',
                    width: 22
                },
                {
                    header: '采集时间',
                    key: 'data_ts',
                    width: 22
                },
                {
                    header: '室温（℃）',
                    key: 'roottemp',
                    width: 15
                },
                {
                    header: '湿度（%）',
                    key: 'humidity',
                    width: 15
                },
                {
                    header: '信号强度',
                    key: 'csq',
                    width: 15
                },
                {
                    header: '电池电量（%）',
                    key: 'bat',
                    width: 15
                },
                {
                    header: '告警标记',
                    key: 'alarm_flags',
                    width: 20
                }
            ]

            worksheet.addRows(
                list.map((item) => {
                    return {
                        IMEI: search_data.value.imei,
                        iccid: item.iccid,
                        ts: item.ts,
                        data_ts: item.data_ts,
                        roottemp: item.roottemp,
                        humidity: item.humidity <= 100 ? item.humidity : '',
                        csq: item.csq,
                        bat: item.bat <= 100 ? item.bat : '',
                        alarm_flags:
                            ((item.flags & (1 << 7)) !== 0 ? '掉电故障' : '') +
                            ((item.flags & (1 << 7)) !== 0 && (item.flags & (1 << 6)) !== 0 ? '，' : '') +
                            ((item.flags & (1 << 6)) !== 0 ? '移位故障' : '')
                    }
                })
            )

            worksheet.getRow(1).alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }
        } else if (Number(tab_active.value) === 2) {
            worksheet.columns = [
                {
                    header: 'IMEI',
                    key: 'IMEI',
                    width: 20
                },
                {
                    header: 'ICCID',
                    key: 'iccid',
                    width: 22
                },
                {
                    header: '上传时间',
                    key: 'ts',
                    width: 22
                },
                {
                    header: '采集时间',
                    key: 'data_ts',
                    width: 22
                },
                {
                    header: '入水温度（℃）',
                    key: 'roottemp',
                    width: 15
                },
                {
                    header: '出水温度（℃）',
                    key: 'humidity',
                    width: 15
                },
                {
                    header: '信号强度',
                    key: 'csq',
                    width: 15
                },
                {
                    header: '电池电量（%）',
                    key: 'bat',
                    width: 15
                },
                {
                    header: '告警标记',
                    key: 'alarm_flags',
                    width: 20
                }
            ]

            worksheet.addRows(
                list.map((item) => {
                    return {
                        IMEI: search_data.value.imei,
                        iccid: item.iccid,
                        ts: item.ts,
                        data_ts: item.data_ts,
                        roottemp: item.roottemp,
                        humidity: item.humidity <= 100 ? item.humidity : '',
                        csq: item.csq,
                        bat: item.bat <= 100 ? item.bat : '',
                        alarm_flags:
                            ((item.flags & (1 << 7)) !== 0 ? '掉电故障' : '') +
                            ((item.flags & (1 << 7)) !== 0 && (item.flags & (1 << 6)) !== 0 ? '，' : '') +
                            ((item.flags & (1 << 6)) !== 0 ? '移位故障' : '')
                    }
                })
            )

            worksheet.getRow(1).alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }
        } else if (Number(tab_active.value) === 3) {
            worksheet.columns = [
                {
                    header: 'IMEI',
                    key: 'IMEI',
                    width: 20
                },
                {
                    header: 'ICCID',
                    key: 'iccid',
                    width: 22
                },
                {
                    header: '上传时间',
                    key: 'ts',
                    width: 22
                },
                {
                    header: '采集时间',
                    key: 'data_ts',
                    width: 22
                },
                {
                    header: '阀门状态',
                    key: 'valve_status',
                    width: 15
                },
                {
                    header: '阀门开度',
                    key: 'opening',
                    width: 15
                },
                {
                    header: '进水温度',
                    key: 'intemp',
                    width: 15
                },
                {
                    header: '出水温度',
                    key: 'outtemp',
                    width: 15
                },
                {
                    header: '信号强度',
                    key: 'csq',
                    width: 15
                },
                {
                    header: '电池电量（%）',
                    key: 'bat',
                    width: 15
                },
                {
                    header: '电压（V）',
                    key: 'voltage',
                    width: 15
                },
                {
                    header: '累计流量（m³/h）',
                    key: 'accflow',
                    width: 15
                },
                {
                    header: '瞬时流量（m³/h）',
                    key: 'instflow',
                    width: 15
                },
                {
                    header: '累计热量（kwh）',
                    key: 'accheat',
                    width: 15
                },
                {
                    header: '累计冷量（kwh）',
                    key: 'acccool',
                    width: 15
                },
                {
                    header: '告警标记',
                    key: 'alarm_flags',
                    width: 20
                }
            ]

            worksheet.addRows(
                list.map((item) => {
                    return {
                        IMEI: search_data.value.imei,
                        iccid: item.iccid,
                        ts: item.ts,
                        data_ts: item.data_ts,
                        valve_status: item.opening > 0 ? '开' : '关',
                        opening: item.opening,
                        intemp: item.intemp,
                        outtemp: item.outtemp,
                        csq: item.csq,
                        bat: item.bat <= 100 ? item.bat : '',
                        voltage: item.voltage,
                        accflow: item.accflow,
                        instflow: item.instflow,
                        accheat: item.accheat,
                        acccool: item.acccool,
                        alarm_flags:
                            ((item.flags & (1 << 7)) !== 0 ? '掉电故障' : '') +
                            ((item.flags & (1 << 7)) !== 0 && (item.flags & (1 << 6)) !== 0 ? '，' : '') +
                            ((item.flags & (1 << 6)) !== 0 ? '移位故障' : '')
                    }
                })
            )

            worksheet.getRow(1).alignment = {
                horizontal: 'center',
                vertical: 'middle'
            }
        }
        // 导出excel文件
        await workbook.xlsx.writeBuffer().then((buffer) => {
            const date = new Date()
            const year = date.getFullYear() // 年
            let month = date.getMonth() + 1 // 月
            let day = date.getDate() // 日
            let hour = date.getHours() // 时
            let minutes = date.getMinutes() // 分
            let seconds = date.getSeconds() // 秒
            // 给一位数的数据前面加 “0”
            if (month >= 1 && month <= 9) month = '0' + month
            if (day >= 0 && day <= 9) day = '0' + day
            if (hour >= 0 && hour <= 9) hour = '0' + hour
            if (minutes >= 0 && minutes <= 9) minutes = '0' + minutes
            if (seconds >= 0 && seconds <= 9) seconds = '0' + seconds
            const presentDate = `室温采集设备监测数据${year}${month}${day}_${hour}${minutes}${seconds}`

            // 导出并存储文件
            FileSaver.saveAs(new Blob([buffer]), `${presentDate}.xlsx`)
        })
        loading.close()
    })
}

onMounted(async () => {
    await getModelList()
    await getRoomTree()
})
</script>

<style lang="scss" scoped>
.total-box {
    font-size: 14px;
    color: #606266;
    line-height: 30px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.total-box span {
    margin-left: 30px;
}
</style>
